const RequestAction = {
  Withdrawal: 'withdrawal',
  TransferSavings: 'transfer-savings',
  Voiding: 'voiding'
};

export default RequestAction;
